import type { DefaultErrorProps } from '@grandvisionhq/www-next/pages/error'

export const defaultErrorProps: DefaultErrorProps = {
  title: 'Irgendwas scheint kaputt zu sein...',
  subheader: 'Sieht aus, als hättest du dich ein wenig verlaufen',
  buttonText: 'Zur startseite zurückkehren',
}
